export const standardBridgeAbi = [
  {
    type: 'function',
    name: 'balanceOf',
    inputs: [{ type: 'address', name: 'account' }],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'approve',
    inputs: [
      { type: 'address', name: 'spender' },
      { type: 'uint256', name: 'amount' },
    ],
    outputs: [{ type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'allowance',
    inputs: [
      { type: 'address', name: 'owner' },
      { type: 'address', name: 'spender' },
    ],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'depositETH',
    inputs: [
      { type: 'uint32', name: '_minGasLimit' },
      { type: 'bytes', name: '_extraData' },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'depositETHTo',
    inputs: [
      { type: 'address', name: '_to' },
      { type: 'uint32', name: '_minGasLimit' },
      { type: 'bytes', name: '_extraData' },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'depositERC20',
    inputs: [
      { type: 'address', name: '_l1Token' },
      { type: 'address', name: '_l2Token' },
      { type: 'uint256', name: '_amount' },
      { type: 'uint32', name: '_minGasLimit' },
      { type: 'bytes', name: '_extraData' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'depositERC20To',
    inputs: [
      { type: 'address', name: '_l1Token' },
      { type: 'address', name: '_l2Token' },
      { type: 'address', name: '_to' },
      { type: 'uint256', name: '_amount' },
      { type: 'uint32', name: '_minGasLimit' },
      { type: 'bytes', name: '_extraData' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const;
